var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-form",
    {
      ref: "form",
      attrs: { "lazy-validation": "" },
      model: {
        value: _vm.valid,
        callback: function ($$v) {
          _vm.valid = $$v
        },
        expression: "valid",
      },
    },
    [
      _c(
        "v-container",
        { staticClass: "fill-height fill-width", attrs: { fluid: "" } },
        [
          _c(
            "v-card",
            {
              staticClass: "mx-auto",
              staticStyle: { "margin-top": "50px" },
              attrs: { "max-width": "400" },
            },
            [
              _c(
                "v-toolbar",
                { attrs: { color: "secondary", dark: "" } },
                [
                  _c("v-toolbar-title", { staticClass: "ml-2" }, [
                    _vm._v(_vm._s(_vm.$t("settings.title"))),
                  ]),
                ],
                1
              ),
              _c("v-card-actions", [
                _c(
                  "div",
                  { staticClass: "sign-out" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "justify-center",
                        attrs: { color: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.signOut()
                          },
                        },
                      },
                      [_vm._v("Sign Out")]
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "v-list",
                { attrs: { "two-line": "", subheader: "" } },
                [
                  _c("v-subheader", [
                    _vm._v(_vm._s(_vm.$t("settings.general"))),
                  ]),
                  _c(
                    "v-list-item",
                    [
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", [
                            _vm._v(
                              _vm._s(_vm.$t("settings.application_version"))
                            ),
                          ]),
                          _c("v-list-item-subtitle", [
                            _vm._v("V " + _vm._s(_vm.appVersion)),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-list-item",
                    [
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-switch", {
                            attrs: { label: _vm.$t("settings.local_mode") },
                            model: {
                              value: _vm.localMode,
                              callback: function ($$v) {
                                _vm.localMode = $$v
                              },
                              expression: "localMode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-list-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.localMode,
                          expression: "localMode",
                        },
                      ],
                    },
                    [
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-text-field", {
                            attrs: {
                              type: "url",
                              label: _vm.$t("settings.flightpath_address"),
                              rules: _vm.addressRules,
                              required: "",
                            },
                            model: {
                              value: _vm.flightPathIp,
                              callback: function ($$v) {
                                _vm.flightPathIp = $$v
                              },
                              expression: "flightPathIp",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", disabled: !_vm.valid },
                      on: { click: _vm.submit },
                    },
                    [_vm._v(_vm._s(_vm.$t("save")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }